import { CommonModule } from '@angular/common';
import { Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../api/services/common.service';
import { FORM_ID } from '../../../helpers/form-id.enum';

@Component({
    selector: 'app-checkbox-type-one',
    imports: [CommonModule, ReactiveFormsModule, FormsModule],
    templateUrl: './checkbox-type-one.component.html',
    styleUrl: './checkbox-type-one.component.css'
})
export class CheckboxTypeOneComponent {
  @Input() checkResponse: any[] = [];
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  selected: boolean = false;
  showValidationError = false;
  fieldsData: any;
  endpoint = environment.api_endpoint;
  selectedOptions: any[] = [];
  otherFrameworksData: any[] = [];
  otherFrameworkSearchText = '';
  hasOtherFrameworkSearch = false;
  isOtherFrameworkLoading = false;
  activeModalContext: any;
  modalTitle: string = '';
  skeletonArray = Array.from({ length: 9 });
  isLoading: boolean = true;
  formId: any;
  @Output() handleTaskMappingDependency = new EventEmitter<{
    fieldName: string;
    tags: any[];
    selectedQuestion: any;
  }>();
  constructor(
    private formService: FormsServiceService,
    private commonService: CommonService,
   private cdr: ChangeDetectorRef) {}
  ngOnInit() {
    this.getData();
    if (!this.control?.value?.length && this.fields?.value?.length) {
      const initialSelection = this.fields.value.map((val: any) =>
        typeof val === 'object' ? val._id?.toString() : val?.toString(),
      );
      this.control?.setValue(initialSelection, { emitEvent: false });
    }

    // Sync tags when control changes
    this.control?.valueChanges.subscribe(() => {
      this.restoreTagsFromSelectedOptions();
     this.cdr.detectChanges();});
  }

  /** Function to get the data by api or static */
  getData() {
    this.isLoading = true;
    if (this.fields.options.isStatic === true) {
      this.isLoading = false;
      this.fieldsData = this.fields.options.staticOptions;
      this.syncSelectionWithData();
    } else {
      const formId = this.fields.options.source.formID;
      const api_endpoint = this.endpoint;
      const method = this.fields.options.source.method;
      let url = this.fields.options.source.apiUrl;
      const replacements = {
        formID: formId,
        api_endpoint: api_endpoint,
      };
      url = this.formService.replaceTemplateTokens(url, replacements);
      const accessToken = localStorage.getItem('accessToken');
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      };
      this.formService.loadData(method, url, headers).subscribe({
        next: (res) => {
          this.fieldsData = res.data.records;
          this.syncSelectionWithData();
          this.isLoading = false;
         this.cdr.detectChanges();},
        error: (err) => {
          this.fieldsData = [];
          this.isLoading = false;
         this.cdr.detectChanges();},
      });
    }
  }

  syncSelectionWithData() {
    if (!this.fieldsData?.length) return;
    const currentValue = (this.control?.value || this.fields?.value || []).map(
      (v: any) => (typeof v === 'object' ? v._id?.toString() : v?.toString()),
    );

    // Filter out any IDs that do not exist in fieldsData
    const validSelection = currentValue.filter((id: string) =>
      this.fieldsData.some((opt: any) => opt._id?.toString() === id),
    );
    if (JSON.stringify(validSelection) !== JSON.stringify(currentValue)) {
      this.control?.setValue(validSelection, { emitEvent: false });
    }
    this.restoreTagsFromSelectedOptions();
  }

  restoreTagsFromSelectedOptions() {
    const currentValue = (this.control?.value || this.fields?.value || []).map(
      (v: any) => v.toString(),
    );
    const fieldName = this.resolveFieldName(this.fields);
    const tagsControl = this.formGroup.get(fieldName + 'Tags');

    if (!currentValue.length || !this.fieldsData) {
      tagsControl?.setValue([], { emitEvent: false });
      this.handleTaskMappingDependency.emit({
        fieldName,
        tags: [],
        selectedQuestion: this.getSelectedQuestion(),
      });
      return;
    }

    const selectedOptions = this.fieldsData.filter((opt: any) =>
      currentValue.includes(opt._id?.toString()),
    );

    // ✅ restore IDs
    this.control?.setValue(
      selectedOptions.map((opt: any) => opt._id),
      { emitEvent: false },
    );

    tagsControl?.setValue(
      selectedOptions.map((opt: any) => this.fields?.options?.source?.formID === '6a3d163923bf07d3d695d993' ? (opt.shortName || opt.name || '') : (opt.name || '')),
      { emitEvent: false },
    );

    // ✅ FIX: emit both field + tags
    this.handleTaskMappingDependency.emit({
      fieldName,
      tags: tagsControl?.value || [],
      selectedQuestion: this.getSelectedQuestion(),
    });
  }

  private resolveFieldName(field: any): string {
    if (!field) return '';

    // ✅ Case 1: direct string
    if (typeof field.fieldName === 'string') {
      return field.fieldName;
    }

    // ✅ Case 2: object { label, value }
    if (field.fieldName?.label) {
      return field.fieldName.label;
    }

    // ✅ Case 3: value[] format
    if (Array.isArray(field)) {
      return this.getValueByKey(field, 'fieldName') || '';
    }

    // ✅ Case 4: field.value is array (very common in your setup)
    if (Array.isArray(field.value)) {
      return this.getValueByKey(field.value, 'fieldName') || '';
    }

    return '';
  }

  private getValueByKey(arr: any[], key: string): any {
    return (arr || []).find((item: any) => item.Key === key)?.Value;
  }

  private getSelectedQuestion(): string {
    if (this.fields?.options?.source?.formID === '6a3d163923bf07d3d695d993') {
      return this.fields?.helpText || this.fields?.displayName || '';
    }
    return this.fields?.displayName || '';
  }

  get control() {
    return this.formGroup.get(this.fields.fieldName);
  }

  private findOptionById(id: string): any {
    return [...(this.fieldsData || []), ...this.otherFrameworksData].find(
      (option: any) => option._id?.toString() === id,
    );
  }

  private openOtherFormModal(option: any): void {
    if (option?.name?.toLowerCase() !== 'other') return;

    const fieldDeps = option?.fieldDependencies || [];
    const onClickDep = fieldDeps.find((dep: any) => dep.trigger === 'onClick');
    if (!onClickDep || !Array.isArray(onClickDep.condition)) return;

    for (const condBlock of onClickDep.condition) {
      const modalCond = condBlock.conditions?.find(
        (condition: any) =>
          condition.type === 'modal' &&
          condition.targetType === 'form' &&
          condition.targetValue,
      );

      if (modalCond) {
        this.otherFrameworkSearchText = '';
        this.hasOtherFrameworkSearch = false;
        this.otherFrameworksData = [];

        const modal = document.getElementById(
          `checkbox_type_one_modal_${this.fields.fieldName}`,
        );
        if (modal) modal.classList.add('show');
        return;
      }
    }
  }

  /** Function to toggle the card and push the selection into array */
  toggleSelection(option: any) {
    const optionId = option._id?.toString();
    const optionName = this.fields?.options?.source?.formID === '6a3d163923bf07d3d695d993' ? (option.shortName || option.name || '') : (option.name || '');

    const currentValue = (this.control?.value || []).map((v: any) =>
      v.toString(),
    );
    let newSelection: string[] = [];
    let newTags: string[] = [];

    if (this.fields.fieldType === 'singleSelect') {
      newSelection = [optionId];
      newTags = [optionName];
    } else {
      if (currentValue.includes(optionId)) {
        newSelection = currentValue.filter((id: string) => id !== optionId);
        newTags = newSelection.map((id) => {
          const opt = this.findOptionById(id);
          return this.fields?.options?.source?.formID === '6a3d163923bf07d3d695d993' ? (opt?.shortName || opt?.name || '') : (opt?.name || '');
        });
      } else {
        newSelection = [...currentValue, optionId];
        newTags = [
          ...newSelection.map((id) => {
            const opt = this.findOptionById(id);
            return this.fields?.options?.source?.formID === '6a3d163923bf07d3d695d993' ? (opt?.shortName || opt?.name || '') : (opt?.name || '');
          }),
        ];
      }
    }

    const fieldName = this.resolveFieldName(this.fields);
    const tagsControl = this.formGroup.get(fieldName + 'Tags');
    const normalizedTags = newTags.filter(
      (tag: any) => tag !== null && tag !== undefined && tag !== '',
    );

    this.control?.setValue(newSelection, { emitEvent: false });
    tagsControl?.setValue(normalizedTags, { emitEvent: false });
    this.control?.markAsTouched();
    this.control?.updateValueAndValidity();
    this.showValidationError =
      this.fields.isRequired && newSelection.length === 0;
    if (newSelection.includes(optionId)) {
      this.openOtherFormModal(option);
    }
    this.handleTaskMappingDependency.emit({
      fieldName,
      tags: normalizedTags,
      selectedQuestion: this.getSelectedQuestion(),
    });
  }

  closeOnBackdropClick(event: MouseEvent, modalId: string) {
    const modal = document.getElementById(modalId);
    if (event.target === modal) {
      this.closeModal(modalId);
    }
  }

  closeModal(modalId: string) {
    const modal = document.getElementById(modalId);
    if (modal) modal.classList.remove('show');
    this.activeModalContext = null;
  }

  onModalFormSaved(event: any): void {
    if (event?.success) {
      this.closeModal(`checkbox_type_one_modal_${this.fields.fieldName}`);
    }
  }

  setModalTitle(title: string) {
    this.modalTitle = title;
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    if (this.fields?.fieldName) {
      this.closeModal(`checkbox_type_one_modal_${this.fields.fieldName}`);
    }
  }

  /** Function to validate the selection */
  validateSelection(): boolean {
    this.selectedOptions = this.control?.value || this.fields?.value;
    if (this.fields.isRequired && this.selectedOptions.length === 0) {
      this.showValidationError = true;
      return false;
    }
    this.showValidationError = false;
    return true;
  }

  isSelected(option: any): boolean {
    const value = (this.control?.value || this.fields?.value || []).map(
      (v: any) => v.toString(),
    );
    return value.includes(option._id?.toString());
  }

  onKeyUpSearch(searchInput: any) {
    const query = searchInput.trim();
    this.otherFrameworkSearchText = query;
    this.formId = FORM_ID.FRAMEWORKS;

    if (query.length < 3) {
      this.hasOtherFrameworkSearch = false;
      this.otherFrameworksData = [];
      this.isOtherFrameworkLoading = false;
      return;
    }

    this.hasOtherFrameworkSearch = true;
    this.loadData(this.formId, { query });
  }

  loadData(formId: any, pagination: { query: string } = { query: '' }) {
    this.isOtherFrameworkLoading = true;
    this.commonService.loadListWithOptions(formId, pagination).subscribe({
      next: (data) => {
        this.otherFrameworksData = data?.data?.records || [];
        this.isOtherFrameworkLoading = false;
       this.cdr.detectChanges();},
      error: (err) => {
        this.otherFrameworksData = [];
        this.isOtherFrameworkLoading = false;
       this.cdr.detectChanges();},
    });
  }
}
